module.exports = __webpack_public_path__ + "img/producer.068d675e.svg";